export default "__VITE_ASSET__425ea975__"